"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/IQFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_113)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_113`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#CE1126"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.38254 11.2771H7.3264C7.43166 10.8771 7.78956 10.5824 8.22465 10.5824V9.18591C6.94044 9.18591 5.90184 10.2315 5.90184 11.5087V12.6666H9.38254C9.50886 12.6666 9.61412 12.7719 9.61412 12.8982V13.3614H4.96851V14.7578H11.0106V12.8982C11.0106 12.007 10.2808 11.2771 9.38254 11.2771ZM12.8632 13.3684V9.18591H11.4738V14.7649H13.7966V13.3684H12.8632ZM17.5089 13.3684V9.18591H16.1194V13.3684H15.6562V11.9789H14.2597V14.7649H18.4422V13.3684H17.5089Z",
					fill: "#547C31"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_113`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as IQFlag };
